import { RESOLUTION_MOBILE } from 'store/actionTypes'
import { DispatchType } from 'types'

export const resolutionMobile = (correct: boolean) => (dispatch: DispatchType) => {
  dispatch({ type: RESOLUTION_MOBILE, payload: correct })
}
